import React from 'react';
import Appoinment from '../Appoinment/Appoinment';
import ExceptionalDental from '../ExceptionalDental/ExceptionalDental';
import Header from '../Header/Header';
import Services from '../Services/Services';
import Testimonial from '../Testimonial/Testimonial';
import Doctors from '../Doctors/Doctors';
import Footer from '../../Shared/Footer/Footer';
import Contact from '../Contact/Contact';
import Blog from '../Blog/Blog';
const Home = () => {
    return (
        <div>
            <Header></Header>
            <Services></Services>
            <ExceptionalDental></ExceptionalDental>
            <Appoinment></Appoinment>
            <Testimonial></Testimonial>
            <Blog></Blog>
            <Doctors></Doctors>
            <Contact></Contact>
            <Footer></Footer>
        </div>
    );
};

export default Home;